import PropTypes from "prop-types";
import {ToggleButtonGroup} from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import _ from 'lodash';

const useSwitchStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.mode === "light" ? "#b0b0b0" : "#393939",
        width: "fit-content",
        borderRadius: 5,
        "&.padding": {
            padding: 3,
        },
    },
    label: {
        fontFamily: "Inter",
        fontWeight: 400,
        textTransform: "none",
        color: theme.palette.mode === "light" ? "#2a2a2a" : "#929292",
        border: "none",
        "&:hover": {
            color: theme.palette.mode === "light" ? "#000000" : "#ffffff",
        },
        "&.small": {
            height: 30,
        },
        "&.medium": {
            height: 35,
        },
        "&.large": {
            height: 40,
        },
    },
    selected: {
        "&&": {
            backgroundColor: "#ffffff",
            color: "#3A3A3A",
            borderRadius: 5,
            "&:hover": {
                backgroundColor: "#ffffff",
                color: "#3A3A3A",
            },
        },
    },
}));


const AgyleToggleButtons = (props) => {
    const classes = useSwitchStyles();

    const handleChange = (e, value) => {
        props.onChange(value, e);
    };

    return (
        <div
            className={clsx(classes.root, props.padding && "padding", props.classNameRoot)}
        >
            <ToggleButtonGroup
                value={props.value}
                exclusive={!props.multiSelect}
                onChange={handleChange}
                orientation={props.orientation}
                size={props.size}
                disabled={props.disabled}
                style={{...props.style}}
                fullWidth={props.fullWidth}
            >
                {props.options?.map(opt => (
                    <ToggleButton
                        key={opt.value}
                        className={clsx(
                            classes.label,
                            props.size,
                            props.classNameLabel
                        )}
                        name={props.name}
                        selected={props.value === opt.value || (opt.description && props.value?.description === opt.description)}
                        classes={{selected: props.classNameSelected ? props.classNameSelected : classes.selected}}
                        sx={{
                            "&.MuiToggleButtonGroup-grouped": {
                                borderRadius: `${props.toggleButtonRadius}px !important`,
                            },
                            minWidth: props.minWidth
                        }}
                        value={(!_.isNull(opt.value) || !_.isUndefined(opt.value)) ? opt.value : opt}
                        disabled={opt.disabled}
                        style={props.style}
                    >
                        {opt.label || opt.description}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </div>
    );
};

export default AgyleToggleButtons;

AgyleToggleButtons.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    orientation: PropTypes.oneOf(["horizontal", "vertical"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    multiSelect: PropTypes.bool,
    padding: PropTypes.bool,
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object,
    toggleButtonRadius: PropTypes.number,
    fullWidth: PropTypes.bool,
};

AgyleToggleButtons.defaultProps = {
    value: false,
    disabled: false,
    multiSelect: false,
    orientation: "horizontal",
    size: "small",
    minWidth: "auto",
    padding: true,
    toggleButtonRadius: 5,
    fullWidth: false,
};